import { useTheme } from '@mui/material';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useParams } from 'react-router-dom';

import { Account, useGetSpotDetailedQuery, Spot } from '@graphql';
import { AccountStatuses, AccountDescription, NameDisplay, NameSlug, RemoveAvatar } from '../common';
import { SpotConfiguration } from './configuration';
import { SpotAtmosphere } from './Atmosphere';
import { SpotBringable } from './Bringable';
import { SpotEquipment } from './Equipment';
import { SpotHighlight } from './Highlight';
import { SpotPayment } from './Payment';
import { SpotService } from './Service';
import { SpotSuitable } from './Suitable';
import { SpotSchedules } from './Schedules';
import { SpotType } from './Type';

export function SearchAccountDisplaySpot() {
  const theme = useTheme();
  const { sSlug, sTab } = useParams();

  const { data, loading } = useGetSpotDetailedQuery({
    skip: !sSlug,
    variables: { slug: sSlug!, withDeletedAt: true },
    fetchPolicy: 'cache-first',
  });

  if (!sSlug) {
    return null;
  }

  if (loading) {
    return (
      <Stack p={2} alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (!data?.spot) {
    return (
      <Stack p={2} justifyContent="center" alignItems="center" height="100%">
        <Typography variant="body2" fontStyle="italic">
          Aucun spot trouvé
        </Typography>
      </Stack>
    );
  }

  const { spot } = data;

  return (
    <Stack spacing={2}>
      {sTab === 'identity' && (
        <Stack width="100%" spacing={5} divider={<Divider />}>
          <Stack
            width="100%"
            direction="row"
            justifyContent="space-between"
            divider={
              <Divider flexItem variant="vertical" sx={{ backgroundColor: theme.palette.grey[600] }} />
            }
          >
            <Stack mx={10} pt={2} spacing={2} justifyContent="center" alignItems="center">
              <Avatar src={spot.avatar?.url} sx={{ width: 100, height: 100 }} />
              <RemoveAvatar account={spot as Account} imageId={spot.avatar?.id} />
            </Stack>
            <AccountStatuses account={spot as Spot} />
          </Stack>
          <NameDisplay id={spot.id} name={spot.name} />
          <NameSlug id={spot.id} slug={spot.slug} />
          <AccountDescription id={spot.id} description={spot.description} />
        </Stack>
      )}
      {sTab === 'configuration' && <SpotConfiguration account={spot as Spot} />}
      {sTab === 'atmosphere' && <SpotAtmosphere account={spot as Spot} />}
      {sTab === 'equipment' && <SpotEquipment account={spot as Spot} />}
      {sTab === 'service' && <SpotService account={spot as Spot} />}
      {sTab === 'suitable' && <SpotSuitable account={spot as Spot} />}
      {sTab === 'payment' && <SpotPayment account={spot as Spot} />}
      {sTab === 'bringable' && <SpotBringable account={spot as Spot} />}
      {sTab === 'type' && <SpotType account={spot as Spot} />}
      {sTab === 'highlight' && <SpotHighlight account={spot as Spot} />}
      {sTab === 'schedules' && <SpotSchedules account={spot as Spot} />}
    </Stack>
  );
}
